/**
* DevExpress Dashboard (data-source-wizard-model.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { DataSourceType } from '@devexpress/analytics-core/analytics-wizard';
const OlapDataSourceType = 3099;
export function ToDataSourceTypeNumber(dashboardType) {
    switch (dashboardType) {
        case 'Sql': return DataSourceType.Sql;
        case 'Json': return DataSourceType.Json;
        case 'Olap': return OlapDataSourceType;
        case 'Federation': return DataSourceType.Federation;
    }
}
export function ToDashboardDataSourceType(typeNumber) {
    switch (typeNumber) {
        case DataSourceType.Sql: return 'Sql';
        case DataSourceType.Json: return 'Json';
        case OlapDataSourceType: return 'Olap';
        case DataSourceType.Federation: return 'Federation';
    }
    throw new Error('Unknown datasource type number: ' + typeNumber);
}
